/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_Seller_TermsInputs */

const en_seller_notice_seller_terms = /** @type {(inputs: Seller_Notice_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller's terms`)
};

const pl_seller_notice_seller_terms = /** @type {(inputs: Seller_Notice_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin sprzedawcy`)
};

/**
* | output |
* | --- |
* | "Seller's terms" |
*
* @param {Seller_Notice_Seller_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_seller_terms = /** @type {((inputs?: Seller_Notice_Seller_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_Seller_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_seller_terms(inputs)
	return en_seller_notice_seller_terms(inputs)
});